import { useGetConversationCount } from 'lib/api/conversations/useConversationCount';
import { useUnreadNotificationQuery } from 'lib/api/notifications/getUnreadNotificationCount';
import React, { ReactNode } from 'react';
import { useAuth } from '../auth';

interface IConversationCount {
  unread: number;
  unassigned: number;
}

interface INotificationProvider {
  conversationCount: IConversationCount | undefined;
  notificationCount: number | undefined;
}
const notificationsState = {} as INotificationProvider;

const NotificationContext = React.createContext(notificationsState);

export const NotificationsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { userData, whitelabel } = useAuth();
  //GET CONVERSATIONS NOTIFICATIONS
  const { data: conversationCount } = useGetConversationCount(
    userData,
    whitelabel
  );
  //GET NOTIFICATIONS COUNT
  const { data: notificationCount } = useUnreadNotificationQuery(userData);

  const value = {
    conversationCount: conversationCount,
    notificationCount: notificationCount?.count,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = React.useContext(NotificationContext);
  if (context === undefined) {
    throw new Error(
      'useNotifications must be used within a NotificationsProvider'
    );
  }
  return context;
};
